import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'

const options = formFieldCommonOptions('AdvancedRadio', {
    validatorFunction(input) {
        return input
    }
})

export default options
